import {createApp} from 'vue'
import App from './App.vue'
import './index.css';
import axios from "axios";
import auth, {clearSession} from "@/auth";

const app = createApp(App)

app.config.globalProperties.$loading = false
app.config.globalProperties.$auth = auth

import router from "@/router";

Intl.DateTimeFormat().resolvedOptions().timeZone = 'Europe/Paris';

axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401 && window.location.pathname !== '/login') {
            clearSession();
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

app.use(router).mount("#app");
